<template>
  <div>
    <div class="row">
      <label class="col-md-2 control-label" for="mode">Set Dealroom Visibility</label>
      <div class="col-md-3">
        <div class="input-group">
          <button
              id="mode"
              type="button"
              class="btn btn-md btn-green"
              @click="onClick($event)"
          >
            {{ btnName }}
          </button>
          <modal-help>
            Click the visibility button to show/hide the offering in the dealroom.
            The offering link will still be active, if the offering is active.
          </modal-help>
        </div>
      </div>
      <h5 v-show="isVisible">{{ message }}</h5>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import ModalHelp from "./ModalHelp"

  export default {
    components: {
      ModalHelp
    },
    props: [
        'slug',
        'offeringMode',
        'offeringId'
    ],
    data() {
      return {
        isVisible: true,
        message: '',
        newMode: this.offeringMode,
        postData: {
          offering: this.offeringId,
          newOfferingMode: ''
        }
      }
    },
  computed: {
    btnName() {
     return this.newMode === '1' ? 'Visible' : 'Hidden'
    }
  },
    created() {
      this.newMode = this.offeringMode
    },
    methods: {
      updateOfferingMode() {
        axios.post('mode',this.postData)
            .then(response => {
              this.message = response.data.status
              return Promise.resolve()
            })
      },
      onClick(event) {
        event.preventDefault()
        this.isVisible = true
        this.newMode = this.newMode === '1' ? '0' : '1'
        this.postData.newOfferingMode = this.newMode
        this.updateOfferingMode()
        this.timer()
      },
      timer() {
        setTimeout(() => {
          this.isVisible = false
          this.message = ''
        }, 3000)
      }
    }
  }
</script>